// import axios from 'axios';

// // Create a new instance of axios
// const apiClient = axios.create({
//   baseURL: process.env.REACT_APP_BACKEND_URL,
// });

// // Add a request interceptor
// apiClient.interceptors.request.use(
//   (config) => {
//     // Check session storage for impersonation state before every request
//     const savedState = sessionStorage.getItem('impersonation_state');
//     if (savedState) {
//       try {
//         const state = JSON.parse(savedState);
//         if (state.isImpersonating && state.currentCustomer?.id) {
//           // If impersonating, add the custom header
//           config.headers['X-Impersonated-Customer-ID'] = state.currentCustomer.id;
//           // console.log(`INTERCEPTOR: Sending request with impersonated customer ID: ${state.currentCustomer.id}`);
//         }
//       } catch (e) {
//         console.error("Could not parse impersonation state from sessionStorage", e);
//       }
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// export default apiClient;

import axios from 'axios';

// Create a new instance of axios
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'https://localhost:5000',
});

// --- NEW ---
// We will store a reference to the Auth0 token-fetching function and validation functions.
let getAccessTokenSilently;
let validateSession;
let isTokenExpired;

// --- NEW ---
// We create an injector function that our React components can call.
// This is a common pattern for giving a plain JS module access to React context/hooks.
export const injectAuthToken = (getter, validationFn, tokenExpiredFn) => {
  getAccessTokenSilently = getter;
  validateSession = validationFn;
  isTokenExpired = tokenExpiredFn;
};


// Add a request interceptor - now marked as async
apiClient.interceptors.request.use(
  async (config) => {
    // --- NEW ---
    // Validate session before making any request
    if (validateSession && !validateSession()) {
      console.error("Session validation failed, request blocked");
      return Promise.reject(new Error("Session expired. Please log in again."));
    }

    // Before sending the request, get the Auth0 token.
    if (getAccessTokenSilently) {
      try {
        const token = await getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: 'openid profile email'
        });

        // Double-check token validity before adding to request
        if (isTokenExpired && isTokenExpired(token)) {
          console.error("Token is expired, request blocked");
          return Promise.reject(new Error("Token expired. Please log in again."));
        }

        // Add the Authorization header to the request config
        config.headers['Authorization'] = `Bearer ${token}`;

      } catch (error) {
        console.error("Could not get Auth0 token", error);
        // If getting the token fails, we can either let the request fail
        // or handle it gracefully. For now, we reject the promise.
        return Promise.reject(error);
      }
    }

    // Check session storage for impersonation state before every request
    const savedState = sessionStorage.getItem('impersonation_state');
    if (savedState) {
      try {
        const state = JSON.parse(savedState);
        if (state.isImpersonating && state.currentCustomer?.id) {
          // If impersonating, add the custom header
          config.headers['X-Impersonated-Customer-ID'] = state.currentCustomer.id;
          // console.log(`INTERCEPTOR: Sending request with impersonated customer ID: ${state.currentCustomer.id}`);
        }
      } catch (e) {
        console.error("Could not parse impersonation state from sessionStorage", e);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;